// Les erreurs du controller arrivent avec le vrai statut HTTP : avec Apollo 3, elles sont
// dans networkError.result.errors plutôt que dans graphQLErrors. On lit les deux.
export const getGraphqlError = (error) => {
  const gqlError = error?.graphQLErrors?.[0] || error?.networkError?.result?.errors?.[0];
  return {
    status: gqlError?.extensions?.status,
    message: gqlError?.message || error?.message || "Erreur inattendue",
    correlationId: gqlError?.extensions?.correlationId,
  };
};

export const formatGraphqlError = (error) => {
  const { message, correlationId } = getGraphqlError(error);
  return correlationId ? `${message} (réf. ${correlationId})` : message;
};
